const MusicLoader = () => (
  <div className="flex justify-center items-center h-32">
    <div className="flex space-x-2">
      <div
        className="w-2 h-6 bg-theme_clr2 animate-pulse"
        style={{ animationDelay: "0s" }}
      ></div>
      <div
        className="w-2 h-6 bg-theme_clr2 animate-pulse"
        style={{ animationDelay: "0.1s" }}
      ></div>
      <div
        className="w-2 h-6 bg-theme_clr2 animate-pulse"
        style={{ animationDelay: "0.2s" }}
      ></div>
      <div
        className="w-2 h-6 bg-theme_clr2 animate-pulse"
        style={{ animationDelay: "0.3s" }}
      ></div>
    </div>
  </div>
);
export default MusicLoader;
